import {
  defaultBase,
  defaultSettings,
} from '@components/Widgets/_contentItems/_baseTemplate'

export const defaultStyling = {
  backgroundColor: 'rgba(0, 0, 0, 0)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}

export default {
  id: '89345024',
  type: 'image',
  category: 'basic',
  ...defaultBase,
  content: {
    url: 'https://assets.onvocado.com/templates/avocado.png',
  },
  settings: {
    ...defaultSettings,
    // action: 'none',
    // href: '',
  },
  /*  Keep the styling even in flattened json structure cause vue ease of use */
  styling: { ...defaultStyling },
}
